export default {
    props: {
        positionBottom: {
            type: Number,
            kComposite: 'position.bottom'
        }, 
        positionLeft: {
            type: Number,
            kComposite: 'position.left'
        }, 
        positionPinned: {
            type: Boolean,
            kComposite: 'position.pinned'
        }, 
        positionRight: {
            type: Number,
            kComposite: 'position.right'
        }, 
        positionTop: {
            type: Number,
            kComposite: 'position.top'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/Position.js